import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './shared/components/footer/footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'entratus-affinity-marketers';
  destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.setupRouterEvents();
  }

  private setupRouterEvents() {
  }
}
